var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"footer-groups"},[_vm._l((_vm.groups),function(group){return _c('FooterGroup',{key:group.id,attrs:{"title":group.title,"links":group.contents}})}),_vm._v(" "),_c('FooterSocials')],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }